export default __webpack_public_path__ + "static/media/pflegenotstand.effd058c.png";